<template>
  <div>
    <div class="scenario_part educationmod scenario_bgs longmod">
      <div class="container">
        <div class="scenario_form">
          <div class="form_outter">
            <div class="form_top">
              <p>子女教育金不難存～現在就來透視一下吧！</p>
              <div class="top_img child">
                <img src="@/assets/images/needs/banner-education/06/child_education.svg" alt="">
              </div>
            </div>
            <div class="form_list">
              <div class="row">
                <div class="col-xs-12 form-group from_main flex">
                  <p class="flex_text">你的生日（民國）
                    <a href="javascript:void(0);" data-html="true" data-tooltip=""></a></p>
                  <div class="flex_box flex">
                    <div class="select_arrow age birthday">
                      <select
                          v-model.number="birthdayY"
                          id="birth_y"
                          class="birth_change pretty-select">
                        <option v-for="year in yearsRange">{{ year }}</option>
                      </select>
                    </div>
                    <div class="select_arrow age birthday">
                      <select v-model.number="birthdayM"
                              id="birth_m"
                              class="birth_change pretty-select">
                        <option v-for="M in 12">{{ M }}</option>
                      </select>
                    </div>

                    <div class="select_arrow age birthday">
                      <select
                          v-model.number="birthdayD"
                          class="pretty-select"
                          id="birth_d">
                        <option v-for="D in daysRange">{{ D }}</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div class="col-xs-12 form-group from_main flex">
                  <p class="radioTitle flex_text">性別</p>
                  <div class="flex_box edu_radio flex">
                    <div class="gender">
                      <input type="radio" id="men" name="gender" v-model="gender" value="MALE">
                      <label for="men"><span class="remind"></span> 男</label>
                    </div>
                    <div class="gender">
                      <input type="radio" id="women" name="gender" v-model="gender" value="FEMALE" checked="checked">
                      <label for="women"> <span class="remind"></span> 女</label>
                    </div>
                  </div>
                </div>

<!--                <div class="col-xs-12 form-group from_main flex" style="position: relative; margin-bottom: 2em">-->
<!--                  <p class="flex_text">所在地-->
<!--                    <a href="javascript:void(0);" data-html="true" data-tooltip=""></a></p>-->
<!--                  <div class="flex_box flex">-->
<!--                    <div class="select_arrow two">-->
<!--                      <select-->
<!--                          id="birth_y"-->
<!--                          v-model="$v.city.$model"-->
<!--                          @change="area = ''"-->
<!--                          class="birth_change pretty-select">-->
<!--                        <option value="">縣市</option>-->
<!--                        <option-->
<!--                            v-for="city in cityCountryData"-->
<!--                            :value="city.CityName">{{ city.CityName }}</option>-->
<!--                      </select>-->
<!--                    </div>-->
<!--                    <div class="select_arrow two">-->
<!--                      <select id="birth_m" v-model="$v.area.$model" class="birth_change pretty-select">-->
<!--                        <option value="">區域</option>-->
<!--                        <option v-for="area in areaList" :value="area.AreaName">{{ area.AreaName }}</option>-->
<!--                      </select>-->
<!--                    </div>-->
<!--                    <div class="error_text"-->
<!--                         style="position: absolute;-->
<!--                                top: 35px;"-->
<!--                         v-if="!$v.area.required && $v.area.$dirty">請選擇所在地</div>-->
<!--                  </div>-->
<!--                </div>-->

                <div class="col-xs-12 form-group from_main flex">
                  <p class="radioTitle flex_text">目前可動用資金</p>
                  <div class="scenario_input">
                    <input
                        class="flex_box"
                        placeholder=""
                        v-model="alreadyPrepareFormat"
                        oninput="value=value.replace(/[^\d\,]/g, '')"
                    >
                    <label data-domain="元"></label>
                    <div class="error_text" v-if="!$v.alreadyPrepare.required && $v.alreadyPrepare.$dirty">
                      輸入可動用資金才能準確分析哦～
                    </div>
                    <div class="error_text" v-if="!$v.alreadyPrepare.between">可動用資金必須介於
                      {{ $v.alreadyPrepare.$params.between.min }} ~ {{ $v.alreadyPrepare.$params.between.max }}
                    </div>
                  </div>

                </div>

                <div class="col-xs-6 col-xs-offset-3 form-group">
                  <div class="share_btn share_btn_orangeDefault">
                    <a v-if="isLoading"><i class='fa fa-spinner fa-spin'></i> 處理中</a>
                    <a v-if="!isLoading" @click.prevent="update">查看結果 Go </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

    </div>
    <ProgressBar :page="page"></ProgressBar>
  </div>
</template>

<script>
import '@/assets/css/scenario_educationFund.css'
import moment from "moment";
import router from "@/router";
import {required, between, integer} from 'vuelidate/lib/validators'
import ProgressBar from '@/components/common/progress_bar'
import {ModuleScenarioMap} from "@/enum/config";

export default {
  name: "education_fund_form",
  components: {
    ProgressBar
  },
  data: function () {
    return {
      page: {
        page_no: 0,
        total: 0
      },
      city: '',
      area: '',
      alreadyPrepare: '',
      gender: 'MALE',
      yearsRange: [],
      birthdayY: 80,
      birthdayM: 10,
      birthdayD: 22,
      buyHouseY: 6,
      buyHouseM: 0,
      isFirst: true,
      isLoading: false,
      cityCountryData: [],
      moduleName: '',
    }
  },
  methods: {
    async init() {
      this.moduleName = await store.get('moduleName')
      if (Object.keys(store.get(`${this.moduleName}@postData`)).length !== 8) {
        this.$router.push({name: this.moduleName})
      } else {
        if (store.get(`${this.moduleName}/data`)) {
          await store.dispatch('getSurvey', {module: this.moduleName, scenario: ModuleScenarioMap[this.moduleName]})
        }
          this.page.total = await store.get(`${this.moduleName}@data`).length - 1
          this.model = await store.get(`${this.moduleName}@data`).find(item => item.page_no === 9)
          this.page.page_no = this.model.page_no
      }
    },
    async update() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        let formData = {
          alreadyPrepare: this.alreadyPrepare,
          gender: this.gender,
          currentAge: this.currentAge,
          birthdayY: this.birthdayY,
          birthdayM: this.birthdayM,
          birthdayD: this.birthdayD,
        }
        this.isLoading = true
        await store.set(`${this.moduleName}/formData`, formData)
        await store.dispatch(`${this.moduleName}/sendSBEductionFundResultDataApi`)
        await store.dispatch(`${this.moduleName}/sendSBCombinePremiumApi`)
        await store.dispatch(`${this.moduleName}/sendTripleIEducationFundApi`)
        await store.dispatch(`${this.moduleName}/setResultData`)
        await store.dispatch(`${this.moduleName}/saveSBData`)
        await router.push({name: `${this.moduleName}_result`, params: { token: store.get(`${this.moduleName}/token`)}});
        this.isLoading = false
      }
    },
    setYearsRange() {
      let yearArr = []
      let nDate = new Date()
      let yearMax = nDate.getFullYear() - 1911 - 18;
      let yearMin = yearMax - 47;
      for (let i = yearMin; i <= yearMax; i++) yearArr.push(i)
      this.yearsRange = yearArr
    },
    setBirthday() {
      let today= new Date();
      this.birthdayY = today.getFullYear() - 1911 - 30
      this.birthdayM = today.getMonth() + 1
      this.birthdayD = today.getDate()
    },
    currency(value) {
      var num = (value || 0).toString(),
          result = '';
      while (num.length > 3) {
        result = ',' + num.slice(-3) + result;
        num = num.slice(0, num.length - 3);
      }
      if (num) {
        result = num + result;
      }
      if (!result.indexOf('-,')) result = result.replace('-,', '-');
      return result;
    }
  },
  created() {
    this.init()
    this.setYearsRange()
    this.setBirthday()
  },
  computed: {
    daysRange: (data) => [1, 3, 5, 7, 8, 10, 12].indexOf(data.birthdayM) === -1 ? 30 : 31,
    currentAge: (data) => {
      let nDate = new Date();
      let n_y = nDate.getFullYear();
      let n_m = nDate.getMonth() + 1;
      let n_d = nDate.getDate();
      let b_y = data.birthdayY + 1911;
      let b_m = data.birthdayM;
      let b_d = data.birthdayD;
      let nD = n_y + '-' + n_m + '-' + n_d;
      let bD = b_y + '-' + b_m + '-' + b_d;
      let nM = moment(nD, 'YYYY-MM-DD');
      let bM = moment(bD, 'YYYY-MM-DD');
      let r_age = nM.diff(bM, 'years', true);
      return Math.round(r_age)
    },
    areaList: (data) => {
      if (data.city !== '') {
        let citySelected = data.cityCountryData.filter(item => item.CityName === data.city)
        return citySelected[0].AreaList
      }
    },
    alreadyPrepareFormat: {
      set(value) {
        if (value === '0' || value === 0 || !value) {
          this.alreadyPrepare = ''
        } else {
          this.alreadyPrepare = parseInt(value.replace(/[,]/g, ""))
        }
      },
      get() {
        if (this.currency(this.alreadyPrepare) === '0') {
          return ''
        }
        return this.currency(this.alreadyPrepare)
      }
    },
  },
  validations: {
    alreadyPrepare: {
      integer,
      required,
      between: between(1, 200000000)
    },
    // city: {
    //   required,
    // },
    // area: {
    //   required,
    // },
  },
}
</script>

<style scoped>
.error_text {
  color: red;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type="number"]{
  -moz-appearance: textfield;
}
</style>